module.exports = __webpack_public_path__ + "static/img/img_feature03.2b079d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/renew_pc/img_feature03.jpg
// module id = Prpm
// module chunks = 0